export const  buildNewSoftwareLicenses = (baseLicenses, licencesWithQty, selectorOrigin) => {
  const newLicences = baseLicenses || [];

  for (const licenceWithQty of licencesWithQty) {
    const licence = newLicences.find(l => l.id === licenceWithQty.id && l.selectorOrigin === selectorOrigin);
    if (licence) {
      licence.quantity += licenceWithQty.quantity;
    } else {
      newLicences.push({...licenceWithQty, selectorOrigin});
    }
  }

  return newLicences;
}


export const removeSoftwareLicenceHelper = (baseLicenses, licenseToRemove) => {
  const newLicences = (baseLicenses || []);
  // Keep only licences where at least one criteria does not match
  return newLicences.filter(l => !(l.id === licenseToRemove.id));
}


export const setSoftwareLicenceQuantityHelper = (baseLicenses, licence, newQuantity) => {

  const newLicences = (baseLicenses || []);
  const licencesToUpdateQuantity = newLicences.filter(l => (l.id === licence.id && l.licenceGroup === licence.licenceGroup && l.licenceCategory === licence.licenceCategory));
  licencesToUpdateQuantity.forEach(licence => {
    licence.quantity = newQuantity;
  });
  return newLicences;
}
